<template>
  <div>
    <navbar :hasSearch="true" />
    <div id="content">
      <div class="row">
        <div class="col-md-6 pb-3">
          <div class="card h-100">
            <ol class="breadcrumb lighten-4 my-auto">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'landingPage' }">
                  <a class="black-text" href="#">Home</a>
                </router-link>
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
              <li class="breadcrumb-item active font-weight-bold">
                Collection Runs
                <i class="fa fa-angle-right mx-2" aria-hidden="true"></i>
              </li>
            </ol>
          </div>
        </div>
        <quick-links></quick-links>
      </div>
      <div class="content_body">
        <div class="container-fluid no-pad">
          <div id="billRun">
            <!-- <div class="container-fluid no-pad">
                    <div class="d-flex p-1 mb-3 bg-white brs border border-light rounded">
                        <div class="p-2">
                            <h3 class="pl-1">Bill Runs</h3>
                        </div>
                    </div>
            </div>-->
            <div class="container-fluid no-pad">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="border border-light rounded">
                        <!-- Refine start -->
                        <form @submit.prevent="submit">
                          <div class="col-sm-12 bg-white brs">
                            <div class="row"></div>
                            <div class="row mt-2">
                              <div class="col-md-12">
                                <h4 class="d-inline">Start a Collection Run</h4>
                                <b-btn no-body bg-variant="transparent" class="btn-hc-nb"
                                  v-b-popover.click.hover="'A collection runs pick up scheduled Direct Debit payments for collection'"
                                  title="What is a collection run?">
                                  <i class="fa fa-question-circle y" aria-hidden="true"></i>
                                </b-btn>
                              </div>
                            </div>
                            <div class="row mt-2">
                              <!-- <div class="col-sm-6 col-md-4 col-lg-3 mb-4">
                                <span class="d-block">Collections due by:</span>
                                <el-date-picker class="pr-4" v-model="pickerDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  type="date" placeholder="Select a date" required>
                                </el-date-picker>
                              </div>-->
                              <div class="col-md-4 pb-3">
                                <div class="d-flex h-100">
                                  <div class="align-self-end">
                                    <!-- <a href="#" class="btn btn-hc mb-0 float-right mb-2" role="button"  @click="submit()">Start
                                    Collection Run</a>-->
                                    <button type="submit" class="btn btn-hc mb-0 float-right mb-2"
                                      :disabled="submitStatus == 'PENDING'" @click="submit()">
                                      Start
                                      Collection Run
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- Refine end -->
                      <div class="border border-light rounded bg-white brs my-3 pl-3 pr-3">
                        <div class="row mt-3 mb-3">
                          <div class="col-md-6 col-xl-4">
                            <h4>Collection Runs</h4>
                          </div>
                          <!-- <div class="col-md-6 col-xl-4 text-fade">
                            <div class="search_75">
                              <form class="input-group md-form form-sm">
                                <input
                                  class="form-control form-control-sm search"
                                  name="search"
                                  placeholder="Search"
                                  autocomplete="off"
                                  type="text"
                                />
                                <div class="input-group-btn">
                                  <a href="#" role="button">
                                    <i class="fa fa-search active" aria-hidden="true"></i>
                                  </a>
                                </div>
                              </form>
                            </div>
                          </div> -->
                        </div>
                        <div class="table-div" v-if="collectionRuns">
                          <b-table id="collection_run_table" striped :items="collectionRunsSorted"
                            :fields="collectionRunFields" :per-page="perPage" :current-page="currentPage"
                            :busy="!collectionRunsSorted.length">
                            <template v-slot:table-busy>
                              <b-row align-h="center">
                                <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                              </b-row>
                            </template>
                            <template slot="Id" slot-scope="data">
                              <!-- <span v-b-popover.click.hover="data.item.Id " class="d-inline p-2 fwfont pointer">{{guidShortener(data.item.Id)}}</span> -->
                              <span class="d-inline p-2 fwfont pointer" v-clipboard:copy="data.item.Id"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">{{guidShortener(data.item.Id)}}</span>
                            </template>
                            <template slot="RunCreated"
                              slot-scope="data">{{data.item.RunCreated | moment('DD.MM.YY HH:mm')}}</template>
                            <template slot="RunCompleted"
                              slot-scope="data">{{data.item.RunCompleted | moment('DD.MM.YY HH:mm')}}</template>
                            <template slot="Stage" slot-scope="data">
                              <p v-if="data.item.Stage === 'Start'">Starting</p>
                              <p v-else-if="data.item.Stage === 'CloudReceive'">Finding Payments</p>
                              <p v-else-if="data.item.Stage === 'CloudRetriveLodgements'">Finding Lodgements</p>
                              <p v-else-if="data.item.Stage === 'CloudMatchLodgements'">Matching payments to lodgements
                              </p>
                              <p v-else-if="data.item.Stage === 'LocalReceive'">Finding bank details</p>
                              <p v-else-if="data.item.Stage === 'LocalMatchLodgements'">
                                Matching lodgements to bank
                                details
                              </p>
                              <p v-else-if="data.item.Stage === 'LocalProduceFile'">Generating collection file</p>
                              <p v-else-if="data.item.Stage === 'LocalSendOutcome'">Created collection file</p>
                              <p v-else-if="data.item.Stage === 'CloudProcessFailures'">Handling any problems</p>
                              <p v-else-if="data.item.Stage === 'Finished'">Finished</p>
                            </template>
                            <template slot="Status" slot-scope="data">{{wordSplit(data.item.Status)}}</template>
                            <template slot="TotalValue" slot-scope="data">
                              {{data.item.TotalValue | currency}}
                              <ClipLoader v-if="data.item.TotalValue == undefined"/>
                              </template>
                            <template slot="Quantity" slot-scope="data">
                              <ClipLoader v-if="data.item.TotalValue == undefined"/>
                              {{data.item.Quantity}}
                            </template>
                            <template slot="payments" slot-scope="data">
                              <a href="#" class="bb" data-toggle="modal" data-target="#CollectionPayments"
                                @click="rowPaymentsClicked(data.item)">View</a>
                            </template>
                            <template slot="logs" slot-scope="data">
                              <!-- This takes you to logs modal -->
                              <a href="#" class="bb" data-toggle="modal" data-target="#PaymentRunLogs"
                                @click="rowLogsClicked(data.item)">View</a>
                            </template>
                          </b-table>
                          <collection-payments></collection-payments>
                          <payment-run-logs></payment-run-logs>
                        </div>
                        <hr />
                        <div class="container-fluid no-pad" v-if="collectionRuns.length!==0">
                          <div class="d-flex overflow-auto my-3">
                            <b-pagination class="my-auto d-flex justify-content-center align-items-center mx-auto"
                              v-model="currentPage" :total-rows="collectionRuns.length" :per-page="perPage"
                              aria-controls="collection_run_table" @input="scrollToTop()">
                              <template v-slot:first-text>
                                <i class="fas fa-angle-double-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:prev-text>
                                <i class="fas fa-chevron-left fa-2x pointer"></i>
                              </template>
                              <template v-slot:next-text>
                                <i class="fas fa-chevron-right fa-2x pointer"></i>
                              </template>
                              <template v-slot:last-text>
                                <i class="fas fa-angle-double-right fa-2x pointer"></i>
                              </template>
                            </b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 12 col close -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- content close -->
</template>
<script>
import Vue from 'vue';
import Navbar from '@/components/Navbar.vue';
import QuickLinks from '@/components/QuickLinks.vue';
import CollectionPayments from '@/components/modals/CollectionPayments.vue';
import PaymentRunLogs from '@/components/modals/PaymentRunLogs.vue';

import { _ } from 'vue-underscore';
import moment from 'moment';

export default {
  components: {
    Navbar,
    QuickLinks,
    PaymentRunLogs,
    CollectionPayments,
  },
  data() {
    return {
      collectionRuns: [],
      collectionRunTotals: [],
      collectionRunsGetter: undefined,
      transactions: {},
      perPage: 9,
      currentPage: 1,
      pickerDate: moment().format('YYYY-MM-DD'),
      submitStatus: null,
      loadedCollectionRuns: [],
      activeService: {
        serial: 0,
      },
      collectionRunFields: {
        Id: {
          label: 'Collection Run Number',
          sortable: true,
          class: 'text-center',
        },
        RunCreated: {
          label: 'Start Date',
          class: 'text-center',
        },
        RunCompleted: {
          label: 'End Date',
          class: 'text-center',
        },
        Stage: {
          label: 'Stage',
          class: 'text-center',
        },
        Status: {
          label: 'Status',
          class: 'text-center',
        },
        TotalValue: {
          label: 'Total Value',
          class: 'text-center',
        },
        Quantity: {
          label: 'Quantity',
          class: 'text-center',
        },
        payments: {
          label: 'Payments',
          class: 'text-center',
        },
        logs: {
          label: 'Logs',
          class: 'text-center',
        },
      },
    };
  },
  computed: {
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    accessToken() {
      return this.$auth.accessToken;
    },
    xsrfToken() {
      return this.$auth.xsrfToken;
    },
    moneybot() {
      return Vue.config.honeycomb.moneybot.domain;
    },
    results() {
      return this.$store.state.results;
    },
    date() {
      return moment.utc(this.pickerDate).format();
    },
    ddbotDomain() {
      return Vue.config.honeycomb.ddbot.domain;
    },
    maxPages() {
      const colRunLength =
        (this.collectionRuns && this.collectionRuns.length) || 0;

      return Math.ceil(colRunLength / this.perPage);
    },

    collectionRunsSorted() {
      let collectionRuns = this.collectionRuns.map((run) => {
        let transactions = this.transactions[run.Id];
        return {
          ...run,
          Quantity: transactions ? transactions.length : undefined,
          TotalValue: transactions
            ? transactions.reduce((total, { Amount }) => Amount + total, 0)
            : undefined,
        };
      });
      return _.sortBy(collectionRuns, 'RunCreated').reverse();
    },

    currentRange() {
      let start = this.perPage * (this.currentPage - 1);
      let end = start + this.perPage;

      return { start, end };
    },

    visibleCollections() {
      return this.collectionRuns.slice(
        this.currentRange.start,
        this.currentRange.end
      );
    },
  },
  methods: {
    scrollToTop() {
      document.getElementById('collection_run_table').scrollIntoView();
    },
    guidShortener: function(guid) {
      var foo = guid.slice(0, 8);
      return foo;
    },
    rowPaymentsClicked({ Id }) {
      this.$store.commit('updateCollectionPayments', this.transactions[Id]);
    },
    rowLogsClicked(item) {
      this.$store.commit('updatePaymentLogs', null);
      this.$store.dispatch('getPaymentLogs', item);
    },
    onCopy(e, elementId) {
      this.$snotify.success(`${e.text} copied to clipboard.`);
      document.getElementById(elementId).click();
    },
    onError() {
      this.$snotify.error(`Failed to copy text to the clipboard.`, {
        timeout: 0,
        closeOnClick: true,
      });
    },
    submit() {
      this.submitStatus = 'PENDING';
      this.$http
        .post(
          'https://' +
            Vue.config.honeycomb.ddbot.domain +
            '/api/v1/Collections',
          {},
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.submitStatus = 'OK';
          this.$snotify.success(`Success! Collection run created.`, {
            timeout: 0,
            closeOnClick: true,
          });
          this.$store.dispatch('getCollectionRuns');
        })
        .catch((error) => {
          // Error
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.data.MoreInformation.length > 0) {
              error.response.data.MoreInformation.forEach((e) => {
                this.$snotify.error(`${e.Error}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              });
            } else {
              this.$snotify.error(`${error.response.data.UserDescription}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.submitStatus = 'Error';
            this.$snotify.error(`No response received.`, {
              timeout: 0,
              closeOnClick: true,
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            this.submitStatus = 'Error';
            this.$snotify.error(`${error.message}`, {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },

    async loadCollectionRuns() {
      for await (const collectionRuns of this.getCollectionRuns()) {
        this.collectionRuns = [...this.collectionRuns, ...collectionRuns];
      }

      await this.loadVisibleTransactions();
    },

    async loadCollectionRunDetails(collectionRun) {
      let transactions = [];

      for await (const data of this.getTransactions(collectionRun.Id)) {
        transactions = [...transactions, ...data];
      }

      this.transactions = {
        ...this.transactions,
        [collectionRun.Id]: transactions,
      };
    },

    async *getCollectionRuns() {
      const domain = 'https://' + this.ddbotDomain + '/api/v1/Collections';
      let continuationToken;

      do {
        let url = domain;
        if (continuationToken) url += `?continuationToken=${continuationToken}`;
        const { data } = await this.$http.get(url, { withCredentials: true });
        continuationToken = data.ContinuationToken;
        yield data.Records;
      } while (continuationToken);
    },

    async *getTransactions(collectionId) {
      this.loadedCollectionRuns.push(collectionId);
      const domain = `https://${
        this.moneybot
      }/api/v1/BankTransactions?collectionId=${collectionId}`;
      let continuationToken;

      do {
        let url = domain;
        if (continuationToken) url += `&continuationToken=${continuationToken}`;
        const { data } = await this.$http.get(url, { withCredentials: true });
        continuationToken = data.ContinuationToken;
        yield data.Records;
      } while (continuationToken);
    },

    async loadVisibleTransactions() {
      const collectionRuns = this.visibleCollections.filter(
        (cr) => !this.loadedCollectionRuns.includes(cr.Id)
      );

      for (const collectionRun of collectionRuns) {
        await this.loadCollectionRunDetails(collectionRun).catch(() => null);
      }
    },
  },
  filters: {
    currency(value) {
      if (value) {
        return value.toLocaleString('en-GB', {
          style: 'currency',
          currency: 'GBP',
        });
      } else if (value == 0) {
        return '£0.00';
      }
    },
  },

  mounted() {
    this.collectionRunsGetter = this.getCollectionRuns();
    this.loadCollectionRuns();
  },

  watch: {
    currentPage() {
      this.loadVisibleTransactions();
    },
  },
};
</script>
